import React, { useState, useRef, useEffect } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const Input = (props) => {
  const [shouldLabelFloat, setShouldLabelFloat] = useState(false);
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef && inputRef.current && inputRef.current.value) {
      setShouldLabelFloat(true);
    }
  }, [inputRef && inputRef.current && inputRef.current.value]);
  return (
    <div className={cn('input-container', props.className)}>
      <label
        className={cn('input-container__label', {
          'input-container__label--focused':
            shouldLabelFloat || props.type == 'date',
          'input-container__label--shadowed': props.shadowed,
          'input-container__label--errored': props.errored,
          'input-container__label--textarea': props.asTextArea,
        })}
      >
        {props.label}
      </label>
      {!props.asTextArea ? (
        <input
          //type={props.type == 'date' ? 'text' : props.type}
          type={props.type}
          readOnly={props.readOnly}
          disabled={props.disabled}
          className={cn('input-container__input', {
            'input-container__input--shadowed': props.shadowed,
            'input-container__input--errored': props.errored,
            'input-container__input--disabled':
              props.readOnly || props.disabled,
          })}
          id={props.name}
          defaultValue={props.defaultValue}
          name={props.name}
          aria-label={props.name}
          max={props.type === 'date' && props.max ? props.max : undefined}
          ref={(ref) => {
            inputRef.current = ref;
            props.setRef(ref);
          }}
          onBlur={(e) => {
            //if (e.target.type == 'date') e.target.type = 'text';
            if (!e.target.value) setShouldLabelFloat(false);
            if (props.onBlur) props.onBlur(e);
          }}
          onFocus={(e) => {
            if (props.type == 'date') e.target.type = 'date';
            setShouldLabelFloat(true);
          }}
          onChange={props.onChange}
          data-gtm-item={props.dataGtmItem}
          data-gtm-detail={props.dataGtmDetail}
        />
      ) : (
        <textarea
          rows={props.rows}
          style={props.resize ? {} : { resize: 'none' }}
          className={cn(
            'input-container__input',
            'input-container__input--textarea',
            {
              'input-container__input--shadowed': props.shadowed,
              'input-container__input--errored': props.errored,
            }
          )}
          id={props.name}
          name={props.name}
          ref={(ref) => {
            inputRef.current = ref;
            props.setRef(ref);
          }}
          onBlur={(e) => {
            if (!e.target.value) {
              setShouldLabelFloat(false);
            }
            if (props.onBlur) props.onBlur(e);
          }}
          onFocus={() => setShouldLabelFloat(true)}
          onChange={props.onChange}
          maxLength={props.max}
          data-gtm-item={props.dataGtmItem}
          data-gtm-detail={props.dataGtmDetail}
          defaultValue={props.defaultValue}
        />
      )}
    </div>
  );
};

Input.propTypes = {
  setRef: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  shadowed: PropTypes.bool,
  errored: PropTypes.bool,
  resize: PropTypes.bool,
  className: PropTypes.string,
  asTextArea: PropTypes.bool,
  type: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  rows: PropTypes.number,
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dataGtmItem: PropTypes.string,
  dataGtmDetail: PropTypes.string,
  defaultValue: PropTypes.string,
};

Input.defaultProps = {
  onChange: null,
  onBlur: null,
  readOnly: false,
  disabled: false,
  shadowed: false,
  errored: false,
  resize: true,
  asTextArea: false,
  max: null,
  type: 'text',
  defaultValue: '',
};

export { Input };
